import { jsx as _jsx } from "react/jsx-runtime";
import './scenario-editor.css';
import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { BlocklyWorkspace } from 'react-blockly';
import * as Blockly from 'blockly';
//@ts-ignore
import * as Ru from 'blockly/msg/ru';
//@ts-ignore
import { DisableTopBlocks } from '@blockly/disable-top-blocks';
//@ts-ignore
import { Backpack } from '@blockly/workspace-backpack';
import { generateToolbox, generateWorkspace } from './generators/workspace';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { selectThemeType } from '../theme/selector';
import { EffectiveThemeType } from '../theme/types';
import { getEffectiveThemeMode } from '../theme/styles/dark-theme';
//@ts-ignore
Blockly.setLocale(Ru);
class MyToolbox extends Blockly.Toolbox {
    getWidth() {
        return 0;
    }
    handleToolboxItemResize() {
        // intentionally empty
    }
}
class MyMetricsManager extends Blockly.MetricsManager {
    getToolboxMetrics() {
        const m = super.getToolboxMetrics();
        return {
            ...m,
            width: 0,
        };
    }
    getUiMetrics() {
        const m = super.getUiMetrics();
        return { ...m, toolboxMetrics: this.getToolboxMetrics() };
    }
    getMetrics() {
        const m = super.getMetrics();
        return { ...m, toolboxWidth: 0 };
    }
}
export function ScenarioEditor(props) {
    const { mobileMode, config, scenario, backpack_contents, onChangeXML, onMeaningfulChangeXML, onSetBackpack, } = props;
    const user_theme_type = useAppSelector(selectThemeType);
    const theme_type = getEffectiveThemeMode(user_theme_type);
    const [workspace, setWorkspace] = useState(null);
    const workspaceXml = useMemo(() => generateWorkspace(config, scenario), [config, scenario]);
    useEffect(() => {
        //@ts-ignore
        workspace?.getToolbox()?.setVisible(props.toolboxVisible);
        //@ts-ignore
        if (props.toolboxVisible)
            workspace?.getToolbox()?.getFlyout()?.hide();
    }, [props.toolboxVisible]);
    return (_jsx(BlocklyWorkspace, { className: "scenario-editor", toolboxConfiguration: generateToolbox(config, scenario), workspaceConfiguration: {
            //см Blockly.Options
            grid: {
                spacing: 20,
                length: 3,
                colour: '#ccc',
                snap: true,
            },
            move: {
                scrollbars: true,
                drag: true,
            },
            zoom: {
                controls: true,
                wheel: true,
                startScale: 1.0,
                maxScale: 3,
                minScale: 0.3,
                scaleSpeed: 1.2,
            },
            comments: false,
            // Blockly.Themes есть
            theme: theme_type === EffectiveThemeType.DARK
                ? //@ts-ignore
                    Blockly.Themes.Dark
                : //@ts-ignore
                    Blockly.Themes.Classic,
            //сюда добавлять плагины: Record<string,  (function(new:?, ...?)|string)>
            plugins: {
                disable_top_plugin: DisableTopBlocks,
                toolbox: mobileMode ? MyToolbox : undefined,
                metricsManager: mobileMode ? MyMetricsManager : undefined,
            },
        }, onXmlChange: onChangeXML, initialXml: workspaceXml, onInject: (data) => {
            data.addChangeListener(Blockly.Events.disableOrphans);
            if (!mobileMode) {
                const backpack = new Backpack(data);
                backpack.init();
                backpack.setContents(backpack_contents);
                onSetBackpack(backpack);
                //@ts-ignore
                Blockly.Msg['EMPTY_BACKPACK'] = 'Очистить рюкзак';
                //@ts-ignore
                Blockly.Msg['REMOVE_FROM_BACKPACK'] = 'Удалить из рюкзака';
                //@ts-ignore
                Blockly.Msg['COPY_TO_BACKPACK'] = 'Скопировать в рюкзак';
                //@ts-ignore
                Blockly.Msg['COPY_ALL_TO_BACKPACK'] = 'Скопировать всё в рюкзак';
                //@ts-ignore
                Blockly.Msg['PASTE_ALL_FROM_BACKPACK'] = 'Вставить всё из рюкзака';
            }
            setWorkspace(data);
            data.addChangeListener((ev) => {
                if (ev instanceof Blockly.Events.BlockChange ||
                    ev instanceof Blockly.Events.BlockDelete ||
                    ev instanceof Blockly.Events.BlockMove) {
                    const xml = Blockly.Xml.domToText(
                    //@ts-ignore
                    Blockly.Xml.workspaceToDom(data));
                    onMeaningfulChangeXML(xml);
                }
            });
            //@ts-ignore
            data.getToolbox()?.setVisible(props.toolboxVisible);
            data.addChangeListener((ev) => {
                // @ts-ignore
                if (ev.type == 'toolbox_item_select') {
                    if (mobileMode) {
                        //@ts-ignore
                        data.getToolbox()?.setVisible(false);
                        props.onToolboxHidden();
                    }
                }
            });
        } }));
}
